//For browser entry
var Fly= require("./dist/npm/fly")
var fly= new Fly;
module.exports = fly;
